import { Link } from "react-router-dom"
import { Icon, type IconName } from "./icons.tsx"

/**
 * 할 일 카드. 숫자를 누르면 그 조건으로 걸러진 목록으로 간다 —
 * 숫자만 보여 주고 어디로도 못 가는 카드는 만들지 않는다.
 */
export function StatCard({
  to,
  label,
  count,
  unit,
  tone = "neutral",
  icon,
  size = "md",
}: {
  to: string
  label: string
  count: number
  unit: string
  tone?: "neutral" | "accent" | "danger"
  icon?: IconName
  size?: "md" | "lg"
}) {
  const classes = ["stat", `stat--${tone}`, `stat--${size}`]
  if (count === 0) classes.push("stat--zero")

  return (
    <Link to={to} className={classes.join(" ")}>
      <div className="stat__top">
        <span className="stat__label">{label}</span>
        {icon ? <Icon name={icon} size={18} className="stat__icon" /> : null}
      </div>
      <div className="stat__count num">
        {count}
        <span className="stat__unit">{unit}</span>
      </div>
      <Icon name="chevronRight" size={16} className="stat__go" />
    </Link>
  )
}
